import React, { useMemo } from 'react'
import { cn } from '../../helpers/utils.js'
import { MulticolItem } from './MulticolDropdown.js'
import CompanyStatsBanner from './CompanyStatsBanner/index.js'

/**
 * 移动端multicol菜单
 * @param multicolMetadata multicol菜单元数据
 */
export const MobileMulticolMenu = ({
  multicolMetadata,
  showStatsBanner,
  statsBannerData,
}: {
  multicolMetadata: any
  showStatsBanner: boolean
  statsBannerData: any
}) => {
  // 是否全部是图片
  const allPicture = useMemo(() => {
    return !multicolMetadata?.some((item: any) => !!item.columns)
  }, [multicolMetadata])

  return (
    <div className="tablet:px-8 laptop:px-16 tablet:gap-6 flex flex-col gap-3 p-4">
      {showStatsBanner && <CompanyStatsBanner data={statsBannerData} />}

      <div
        className={cn(' flex flex-col gap-4', {
          ['tablet:grid tablet:grid-cols-2 tablet:gap-3 laptop:gap-4']: allPicture,
        })}
      >
        {multicolMetadata?.map((item: any, index: number) => (
          <div key={`multicolItem-${item?.label}-${index}`}>
            <MulticolItem item={item} allPicture={allPicture} />
          </div>
        ))}
      </div>
    </div>
  )
}
